import { Collection, CompositeView, util } from '@glu/core';
import RowView from './rowView';

import template from './subGridView.hbs';

/**
 * Renders a properly formatted table view inside a Glu grid by pulling a collection off the row model with the options
 * passed in through rowSubViewOptions in the grid initialization.
 *
 * Currently supported options:
 *  columns: array of column definitions written to match the standard grid column options (currently only supports label, field, url, and format)
 *  collectionName: string value of the collection as stored on the model - defaults to 'children'
 *
 * @exports SubGridView
 */
export default CompositeView.extend({
  template,

  tagName: 'table',

  className: 'table',
  itemView: RowView,

  itemViewOptions() {
    return {
      columns: this.columns
    };
  },

  initialize(options) {
    this.collectionName = options.collectionName || this.collectionName || 'children';
    this.showOnSubRowExpanded = !util.isNullOrUndefined(options.showOnSubRowExpanded) ? options.showOnSubRowExpanded : this.showOnSubRowExpanded;
    this.columns = options.columns || this.columns;

    this.initSubrow();
  },

  serializeData() {
    return util.extend({
      showSubGrid: this.showSubGrid,
      columns: this.showSubGrid ? this.columns : []
    }, this.model.toJSON());
  },

  /**
   * Initializes the subGridView to either show an empty element or a sub grid of data depending on whether the showOnSubRowExpanded option is enabled and sub row is expanded.
   * If showOnSubRowExpanded is not defined the sub grid is always rendered from the start.  If it is true then we wait until the sub row is expanded before rendering html and data.
   *
   * For performance reasons it is highly recommended that you use showOnSubRowExpanded unless your number of main grid rows and subrows is extremely small as rendering all the subrows
   * at grid render time is CPU/DOM intensive and will slow down showing the grid as well as sorting and paging operations.
   */
  initSubrow() {
    if (!this.showOnSubRowExpanded || this.subRowExpanded) {
      this.collection = new Collection(this.model.get(this.collectionName));
      this.itemViewContainer = 'tbody';
      this.showSubGrid = true;
    } else {
      this.collection = new Collection();
      this.itemViewContainer = null;
      this.showSubGrid = false;
    }
  },

  /**
   * Setup the subGridView to show itself when the subrow it is in is expanded.
   */
  onSubRowExpanded() {
    if (!this.subRowExpanded) {
      this.subRowExpanded = true;
      this.initSubrow();
      this.render();
    }
  }
});
